var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#FF7916"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1268 10.5123C14.3819 10.2605 14.3762 9.85777 14.1142 9.61271C13.8521 9.36765 13.4328 9.3731 13.1777 9.62488L11.0191 11.7555L10.0932 11.0425C9.8078 10.8227 9.39102 10.8668 9.16227 11.141C8.93351 11.4151 8.9794 11.8155 9.26477 12.0352L10.8946 13.2904C11.0277 13.3929 11.22 13.3815 11.339 13.264L14.1268 10.5123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5791 5.35788C11.0926 4.88071 11.9074 4.88071 12.4209 5.35788L13.3008 6.17565L14.513 6.01093C15.2204 5.91482 15.8796 6.37494 16.003 7.05091L16.2146 8.20937L17.2961 8.76062C17.9271 9.08228 18.1789 9.82677 17.8652 10.4433L17.3275 11.5L17.8652 12.5567C18.1789 13.1732 17.9271 13.9177 17.2961 14.2394L16.2146 14.7906L16.003 15.9491C15.8796 16.6251 15.2204 17.0852 14.513 16.9891L13.3008 16.8243L12.4209 17.6421C11.9074 18.1193 11.0926 18.1193 10.5791 17.6421L9.6992 16.8243L8.48697 16.9891C7.77963 17.0852 7.12039 16.6251 6.99696 15.9491L6.78544 14.7906L5.70394 14.2394C5.07288 13.9177 4.82108 13.1732 5.13481 12.5567L5.67248 11.5L5.13481 10.4433C4.82108 9.82677 5.07288 9.08228 5.70394 8.76062L6.78544 8.20937L6.99696 7.05091C7.12039 6.37494 7.77963 5.91482 8.48697 6.01093L9.6992 6.17565L10.5791 5.35788ZM11.5 6.27235L12.8452 7.52257L14.6985 7.27074L15.0219 9.04181L16.6753 9.88457L15.8533 11.5L16.6753 13.1154L15.0219 13.9582L14.6985 15.7293L12.8452 15.4774L11.5 16.7276L10.1548 15.4774L8.30148 15.7293L7.9781 13.9582L6.32469 13.1154L7.14669 11.5L6.32469 9.88457L7.9781 9.04181L8.30148 7.27074L10.1548 7.52257L11.5 6.27235Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignName);
export default __webpack_public_path__ + "static/media/campaign-name.31779af63975fa7708a3eac241cfba95.svg";
export { ForwardRef as ReactComponent };